import { useQuery } from '@tanstack/react-query'
import { fetchAllReportsByProductId } from '@services/api/reportAPI'
import { IProduct } from '@store/ProductStore'
import { products as defaultProducts } from '../../../constants/products'

const products: IProduct[] = defaultProducts

export interface IFetchReportsByPlanIdQuery {
  planId: string
  productId: string
}

export const useFetchReportsByPlanIdQuery = ({ planId, productId }) => {
  return useQuery({
    queryKey: ['products', { planId, productId }],
    queryFn: () => fetchAllReportsByProductId({ planId, productId }),
    select: reports => {
      if (!reports) return products

      const product = products?.find(product => product?.id === productId)

      if (!product) return products

      return [
        ...products.filter(product => product?.id !== productId),
        {
          ...product,
          reports: reports?.filter(report => report.productId === product?.guid || report.productId === product?.id) ?? [],
        },
      ]
    },
    initialData: [],
    enabled: !!planId && !!productId,
    refetchOnWindowFocus: false,
  })
}
